<template>
    <keep-alive :include="keepAliveIncludes">
        <router-view />
    </keep-alive>
</template>

<script>
    export default {
        name: 'app',
        components: {
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            hubConection() {
                return this.$store.state.hubConection
            },
            keepAliveIncludes() {
                return this.$router.options.routes
                    .filter(route => route.meta && route.meta.keepAlive)
                    .map(route => {
                        const component = route.component
                        return (component && (component.name || (component.options && component.options.name))) || route.name
                    })
            },
        },
        mounted: function () {
            //const script = document.createElement('script');
            //script.src = './assets/js/bundle.js?v1310';
            //document.body.appendChild(script);

            //const script2 = document.createElement('script');
            //script2.src = './assets/js/app.js?v1310';
            //document.body.appendChild(script2);

            document.addEventListener("DOMContentLoaded", function () {
                document.addEventListener('hide.bs.modal', function () {
                    if (document.activeElement) {
                        document.activeElement.blur();
                    }
                });
            });
        },
    };
</script>

<style >
    .m-modal-body {
        position: unset !important;
    }

    .modal-open{
        overflow: hidden !important;
    }

    .popover-body {
        max-width: 32vw !important;
        
    }
        .popover-body p, .popover-body span {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box !important;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 25;
            margin-bottom: unset;
        }


    .reduz-texto-1, .reduz-texto-2, .reduz-texto-3, .reduz-texto-4, .reduz-texto-5, .reduz-texto-6, .reduz-texto-7, .reduz-texto-8 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box !important;
        -webkit-box-orient: vertical;
    }
    .reduz-texto-1 { -webkit-line-clamp: 1; }
    .reduz-texto-2 { -webkit-line-clamp: 2; }
    .reduz-texto-3 { -webkit-line-clamp: 3; }
    .reduz-texto-4 { -webkit-line-clamp: 4; }
    .reduz-texto-5 { -webkit-line-clamp: 5; }
    .reduz-texto-6 { -webkit-line-clamp: 6; }
    .reduz-texto-7 { -webkit-line-clamp: 7; }
    .reduz-texto-8 { -webkit-line-clamp: 8; }

    .popover-body{
        color: black;
    }
</style>

